import { TranslateService } from '@ngx-translate/core';

import { de_DE, en_US, zh_CN } from 'ng-zorro-antd/i18n';

import { languages } from '@app/configurations';

export function getLocaleFactory(ts: TranslateService): typeof de_DE | typeof zh_CN | typeof en_US {
  const lang =
    (typeof URLSearchParams !== 'undefined' && new URLSearchParams(location.search).get('lang')) ||
    ts.currentLang ||
    ts.getBrowserLang();

  if (lang.toUpperCase() === languages.GERMAN) {
    return de_DE;
  } else if (lang.toUpperCase() === languages.CHINESE) {
    return zh_CN;
  } else {
    return en_US;
  }
}

export function getLocaleIdFactory(ts: TranslateService): string {
  return getLocaleFactory(ts).locale;
}
